import {
  FileImage,
  FolderOpen,
  Grid2X2,
  PaintBucket,
  Palette,
  Sliders,
} from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const features = [
  {
    name: "Tiling",
    description: "Generate seamless tilesets using Wave Function Collapse",
    icon: Grid2X2,
    href: "/workspace/tiling",
    color: "bg-primary",
  },
  {
    name: "Patterning",
    description: "Extract and generate patterns from your images",
    icon: PaintBucket,
    href: "/workspace/patterning",
    color: "bg-secondary",
  },
  {
    name: "Styling",
    description: "Apply artistic styles to your images",
    icon: Palette,
    href: "/workspace/styling",
    color: "bg-accent",
  },
  {
    name: "Asset Manager",
    description: "Manage your uploaded images and generated content",
    icon: FileImage,
    href: "/assets",
    color: "bg-info",
  },
  {
    name: "Projects",
    description: "Organize your work into projects",
    icon: FolderOpen,
    href: "/projects",
    color: "bg-success",
  },
  {
    name: "Presets",
    description: "Save and load generation settings",
    icon: Sliders,
    href: "/presets",
    color: "bg-warning",
  },
];

export default function Home() {
  return (
    <div className="container mt-9 mx-auto px-4 py-8">
      <div className="text-center mb-12">
        <h1 className="filter drop-shadow text-7xl font-bold bg-gradient-to-r from-pink-500 to-violet-500 bg-clip-text text-transparent mb-4">
          Welcome to førmul8r
        </h1>
        <p className="drop-shadow text-xl opacity-80">
          Create seamless textures, generate patterns, and transform your images
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map((feature) => {
          const Icon = feature.icon;
          return (
            <Link
              key={feature.name}
              to={feature.href}
              className="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow"
            >
              <div className="card-body">
                <div
                  className={`w-12 h-12 rounded-lg ${feature.color} flex items-center justify-center mb-4`}
                >
                  <Icon className="w-6 h-6 text-base-100" />
                </div>
                <h2 className="card-title">{feature.name}</h2>
                <p className="opacity-80">{feature.description}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
